import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';

interface FooterProps {
  backgroundColor?: string;
}

const FooterContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
`;

const MountainBottomContainer = styled.div<{ $backgroundColor: string }>`
  position: relative;
  width: 100%;
  height: 400px;
  z-index: 25;
  background: linear-gradient(
    to bottom,
    ${props => props.$backgroundColor} 0 calc(100% - 8px),
    ${colors.neutral.darkBrown} calc(100% - 8px) 100%
  );
  margin: 0;
  margin-bottom: -4px;
  padding: 0;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 8px;
    background-color: ${colors.neutral.darkBrown};
    pointer-events: none;
    z-index: 2;
  }

  @media (max-width: 768px) {
    height: 300px;
  }

  @media (max-width: 480px) {
    height: 250px;
  }
`;

const MountainBottomImage = styled.img<{ $backgroundColor: string }>`
  width: 100%;
  height: calc(100% + 4px);
  object-fit: cover;
  object-position: center bottom;
  display: block;
  position: relative;
  bottom: -4px;
  z-index: 1;

  @media (max-width: 768px) {
    object-position: center bottom;
  }

  @media (max-width: 480px) {
    object-position: center bottom;
  }
`;

const FooterContent = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 40px 20px;
  /* Add extra padding for mobile Safari safe areas */
  padding-bottom: calc(40px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  background-color: ${colors.neutral.darkBrown};
  margin: 0;
  margin-top: -4px;
  
  @media (max-width: 480px) {
    /* Ensure enough space on mobile devices */
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
  }
`;

const FooterLogo = styled.img`
  height: 60px;
  width: auto;
  max-width: 200px;

  @media (max-width: 768px) {
    height: 50px;
  }

  @media (max-width: 480px) {
    height: 40px;
  }
`;

const CopyrightText = styled.p`
  color: ${colors.primary.lightGold};
  font-family: 'GremeryTwo', cursive;
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
  letter-spacing: 1px;

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const Footer: React.FC<FooterProps> = ({ backgroundColor = colors.primary.lightTan }) => {
  return (
    <FooterContainer>
      <MountainBottomContainer $backgroundColor={backgroundColor}>
        <MountainBottomImage 
          src="/images/mountains/mountain-bottom.svg" 
          alt="Mountain bottom" 
          $backgroundColor={backgroundColor}
        />
      </MountainBottomContainer>
      <FooterContent>
        <FooterLogo src="/images/agave-full-logo.png" alt="Agave Logo" />
        <CopyrightText>© 2026 Emery & Grant. All rights reserved.</CopyrightText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 